import type { JSX } from "solid-js";

export type FilterType = "all" | "page";

export interface SearchResult {
  type: "page";
  id: string;
  text: string | null;
  icon: string | null;
}

export interface QuickAction {
  id: string;
  label: string;
  shortcut?: string;
  icon: () => JSX.Element;
  action: () => void;
}

export const FILTER_TYPES: readonly FilterType[] = ["all", "page"];
